import { SalaryFilterKeyString } from 'InstitutionalManagement/types'
import { SALARY_FIELDS_INITIAL_VALUES } from './salaryFieldsInitialValues'

export const SALARY_INITIAL_FILTER: SalaryFilterKeyString = {
  search: '',
  ...SALARY_FIELDS_INITIAL_VALUES,
}
